// extracted by mini-css-extract-plugin
export var card = "_9w-0";
export var expandedCard = "_9w-2";
export var paginated = "_9w-1";